import { reviewBodySchemaWithAdditionalInferredInfo } from "@redotech/redo-model/review/review-body-schema";
import { array, number, object, optional, string, enum as zEnum } from "zod";

export enum ReviewSortOption {
  MOST_RECENT = "most_recent",
  OLDEST = "oldest",
  HIGHEST_RATING = "highest_rating",
  LOWEST_RATING = "lowest_rating",
}

export const getSortedProductReviews = {
  input: object({
    productId: string(),
    page: optional(number().min(1).default(1)),
    pageSize: optional(number().min(1).max(50).default(10)),
    ratingFilter: optional(number().min(1).max(5)),
    sortOption: optional(
      zEnum([
        ReviewSortOption.MOST_RECENT,
        ReviewSortOption.OLDEST,
        ReviewSortOption.HIGHEST_RATING,
        ReviewSortOption.LOWEST_RATING,
      ]).default(ReviewSortOption.MOST_RECENT),
    ),
  }),
  output: object({
    reviews: array(reviewBodySchemaWithAdditionalInferredInfo),
    totalCount: number(),
    totalPages: number(),
    currentPage: number(),
    pageSize: number(),
  }),
};
